import React, { useEffect } from 'react';

const ImpressumPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Impressum | DigitalGigs';
  }, []);

  return (
    <main className="pt-36 pb-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">Legal Notice</p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-12">Impressum</h1>

        <div className="space-y-10 text-slate-600 font-medium leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Angaben gemäß § 5 DDG</h2>
            <p>
              Ajedolabomi Olatifewa Okulaja<br />
              DigitalGigs<br />
              Klemensgasse 5A<br />
              56856 Zell (Mosel)<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Kontakt</h2>
            <p>
              E-Mail:{' '}
              <a href="mailto:digitalgig24@gmail.com" className="text-emerald-600 font-bold hover:text-emerald-700">
                digitalgig24@gmail.com
              </a>
              <br />
              WhatsApp:{' '}
              <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="text-emerald-600 font-bold hover:text-emerald-700">
                go.digitalgigs.eu/chat
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>Ajedolabomi Olatifewa Okulaja, Anschrift wie oben.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Verbraucherstreitbeilegung</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Haftung für Links</h2>
            <p>
              Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default ImpressumPage;
